import Model, { attr } from '@ember-data/model';

export enum ComplianceDocumentStatus {
  held = 'held',
  expiring = 'expiring',
  expired = 'expired',
  // Archived by the renewal that took its place, which the API tells apart from
  // a record that was simply put away.
  renewed = 'renewed',
  archived = 'archived',
}

const CLOSED_STATUSES: ComplianceDocumentStatus[] = [
  ComplianceDocumentStatus.renewed,
  ComplianceDocumentStatus.archived,
];

const MISCELLANEOUS_TYPE = 'other';

// Only the summary a compliance task carries. The record itself belongs to the React
// compliance app, which loads it on its own.
export default class ComplianceDocumentModel extends Model {
  @attr('string') documentType!: string;
  @attr('string') status!: ComplianceDocumentStatus;
  @attr('string') expiryDate?: string;
  @attr('array') reminderLeadDays!: number[];

  // The compliance app renews any record but a miscellaneous one, and an archived
  // one, renewed or put away, is no longer the record to renew.
  get isRenewable(): boolean {
    return (
      this.documentType !== MISCELLANEOUS_TYPE &&
      !CLOSED_STATUSES.includes(this.status)
    );
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'compliance-document': ComplianceDocumentModel;
  }
}
